export const manufacturers = ['Hikvision', 'Axis', 'UNV', 'TVI']
